import ApiClient from "Store/client";

export const fetchLessonsHintsApi = () => ApiClient<Hint[]>(`api/lessons/names`);

export const fetchWorksheetsHintsApi = () => ApiClient<Hint[]>(`api/worksheets/names`);

export const fetchUnitsApi = () => ApiClient("api/units");

export const fetchCoursesApi = () => ApiClient("api/courses");

export const fetchCategoriesApi = () => ApiClient(`api/categories`);

export const fetchLessonTemplateApi = (lesson_id) => ApiClient(`api/lessons/${lesson_id}`);

export const fetchWorksheetTemplateApi = (worksheet_id) =>
  ApiClient(`api/worksheets/${worksheet_id}`);

export const fetchWorksheetsSubjectsApi = () => ApiClient(`api/worksheets/subjects`);

export const fetchWorksheetsContentTypesApi = () => ApiClient(`api/worksheets/content-types`);

export const fetchSubjectsApi = () => ApiClient(`api/subjects`);

export const sendWelcomeEmailApi = (body: WelcomeEmailData) =>
    ApiClient(`api/commands/welcome-email`, {
        method: "POST",
        body
    });
export const sendWorkbookEmailApi = (body: WelcomeEmailData) =>
    ApiClient(`api/commands/workbook-email`, {
        method: "POST",
        body
    });

export const fetchAllTestsTemplatesApi = () => ApiClient<TestTemplate>(`api/tests`);
export const fetchTestSectionTemplatesApi = (testId, sectionId) =>
  ApiClient(`api/tests/${testId}/sections/${sectionId}`);

export const fetchLessonsTemplatesApi = (parameters: string) =>
  ApiClient(`api/lessons${parameters}`);

export const fetchWorksheetsTemplatesApi = (parameters: string) =>
  ApiClient(`api/worksheets${parameters}&worksheet_type=built_in`);

export const fetchLessonsTypesApi = () => ApiClient(`api/lesson/types`);

export const fetchLessonsCategoriesApi = () => ApiClient(`api/lesson/units`);

export const fetchLessonsSubjectsApi = () => ApiClient(`api/lesson/subjects`);

export const fetchTemplateTestApi = (testId: string) =>
  ApiClient<TestTemplate>(`api/tests/${testId}`);
